import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function AnimationOverlay ({isAnimating}){
    
    return isAnimating ? <div className='animation-overlay'></div> : null;
}

export default AnimationOverlay;